"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Table_meta_1 = require("../Table.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('section', Table_meta_1.TABLE_CATEGORY_KEY, Table_meta_1.TABLE_COMPONENT_KEY, ['listGroup']);